import { Component, input } from '@angular/core';
import { TagModule } from 'primeng/tag';

/** Sévérités acceptées par p-tag (primeng/tag). */
export type StatusTagSeverity = 'success' | 'info' | 'warn' | 'danger' | 'secondary' | 'contrast';

/**
 * Enrobage présentationnel de p-tag : `<p-tag [rounded]="true">` avec les
 * mêmes 3 bindings répétés tels quels sur users/properties/ads/documents.
 * Le mapping label/sévérité reste dans chaque page (logique métier propre
 * à chaque enum de statut) — ce composant n'est que la coquille visuelle.
 */
@Component({
  selector: 'app-status-tag',
  standalone: true,
  imports: [TagModule],
  template: `<p-tag [value]="label()" [severity]="severity()" [rounded]="true" />`
})
export class AppStatusTag {
  label = input.required<string>();
  severity = input.required<StatusTagSeverity>();
}
